// ============================================================================
// Sync Dashboard — main sync management page
//
// Contains sub-tabs for different sync integrations:
//   - Merchant Center
//   - Accounts
// ============================================================================
import { BankOutlined, FileSearchOutlined, ShoppingOutlined, SyncOutlined } from "@ant-design/icons";
import { Tabs } from "antd";
import React from "react";
import { usePermissions } from "../../custom_hooks/permission/permission_hook";
import AccountPage from "../account";
import MerchantCenterSyncTab from "./merchant_center_sync_tab";
import SitemapPagesTab from "./sitemap_pages_tab";
import styles from "./index.module.scss";

const SyncDashboard: React.FC = () => {
  const { hasPermission } = usePermissions();
  const canSync = hasPermission("sync.read");
  const canAccounts = hasPermission("zoho.account");

  const items = [];

  if (canSync) {
    items.push({
      key: "merchant-center",
      label: (
        <span>
          <ShoppingOutlined /> Merchant Center
        </span>
      ),
      children: <MerchantCenterSyncTab />,
    });
    items.push({
      key: "sitemap-pages",
      label: (
        <span>
          <FileSearchOutlined /> Sitemap Pages
        </span>
      ),
      children: <SitemapPagesTab />,
    });
  }

  if (canAccounts) {
    items.push({
      key: "accounts",
      label: (
        <span>
          <BankOutlined /> Accounts
        </span>
      ),
      children: <AccountPage />,
    });
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <SyncOutlined className={styles.headerIcon} />
        <h2 className={styles.headerTitle}>Sync Dashboard</h2>
      </div>

      <Tabs defaultActiveKey={canSync ? "merchant-center" : "accounts"} size="large" items={items} />
    </div>
  );
};

export default SyncDashboard;
